<script setup>
import { ref, onMounted, watch } from 'vue'
import { useToast } from 'primevue/usetoast'
import { useConfirm } from "primevue/useconfirm"
import { FilterMatchMode } from 'primevue/api'
import { useRouter } from 'vue-router'
import axios from 'axios'

/////////////////////
// Interface Props //
/////////////////////
const loader = ref(false)
const toast = useToast()
const confirm = useConfirm()
const router = useRouter()

//const emits = defineEmits(['chatCallback'])

const props = defineProps({
    channel: { type: String, required: true }
})

const pipeline = ref(null)
const pipelines = ref([])
const stages = ref([])
const stage = ref(null)
const stage_fields = ref([])

onMounted( async () => {
    get_pipelines()
})

const get_pipelines = () => {
    loader.value = true
    axios.get(process.env.VUE_APP_NEURAXIS_API_MAIN + '/gartenkultur/crm/get-pipelines')
    .then(response => {
        console.log("pipelines", response.data)
        pipelines.value = response.data
        loader.value = false
    })
}

const get_stages = (pipeline) => {
    loader.value = true
    axios.get(process.env.VUE_APP_NEURAXIS_API_MAIN + '/gartenkultur/crm/get-stages?pipeline=' + pipeline)
    .then(response => {
        console.log("stages", response.data)
        stages.value = response.data
        loader.value = false
    })
}

const get_stage_fields = (pipeline, stage) => {
    loader.value = true
    axios.get(process.env.VUE_APP_NEURAXIS_API_MAIN + '/gartenkultur/crm/get-stage-fields?pipeline=' + pipeline + '&stage=' + stage)
    .then(response => {
        console.log("stage_fields", response.data)
        stage_fields.value = response.data
        loader.value = false
    })
}

const field_types = ref([
    {name: "Text", value: "text"},
    {name: "Zahl", value: "number"},
    {name: "Währung", value: "currency"},
    {name: "Datum", value: "date"},
    {name: "Auswahl", value: "select"},
    {name: "Checkbox", value: "checkbox"},
    {name: "Absatz", value: "textarea"},
    {name: "Editor", value: "editor"}
])

const edit_stage = ref([])
const edits_stages = ref(0)

const edit_stage_field = ref([])
const edits_stage_fields = ref(0)

const save_stage = (event) => {
    console.log("edit_stage", event)
    let { newData, index } = event
    stages.value[index] = newData
    edits_stages.value++
    toast.add({severity:'success', summary:'Erfolg', detail:'Phase wurde umbenannt', life: 3000})
}

const reorder_stages = (event) => {
    console.log("reorder_stages", event)
    stages.value = event.value
    edits_stages.value++
    toast.add({severity:'success', summary:'Erfolg', detail:'Die Sortierung wurde geändert', life: 3000})
}

const create_stage = () => {
    stages.value.push({name: "", id: null})
    edits_stages.value++
    toast.add({severity:'success', summary:'Erfolg', detail:'Neue Phase wurde hinzugefügt', life: 3000})
}

const check_for_empty_names = () => {
    let empty_names = stages.value.filter(stage => stage.name == "")
    console.log("empty_names", empty_names)
    if (empty_names.length > 0) {
        return true
    }
    return false
}

const reorder_stage_fields = (event) => {
    console.log("reorder_stage_fields", event)
    stage_fields.value = event.value
    edits_stage_fields.value++
    toast.add({severity:'success', summary:'Erfolg', detail:'Die Sortierung wurde geändert', life: 3000})
}

const create_stage_field = () => {
    stage_fields.value.push({name: "", type: "text", meta_data: [], id: null, required: false})
    edits_stage_fields.value++
    toast.add({severity:'success', summary:'Erfolg', detail:'Neues Feld wurde hinzugefügt', life: 3000})
}

const save_stage_field = (event) => {
    console.log("edit_stage_field", event)
    let { newData, index } = event
    stage_fields.value[index] = newData
    edits_stage_fields.value++
    toast.add({severity:'success', summary:'Erfolg', detail:'Feld wurde umbenannt', life: 3000})
}

const save_stages = () => {
    loader.value = true
    console.log("save_stages", stages.value)
    axios.post(process.env.VUE_APP_NEURAXIS_API_MAIN + '/gartenkultur/crm/save-stages', {pipeline: pipeline.value, stages: stages.value})
    .then(response => {
        console.log("save_stages", response.data)
        loader.value = false
        edits_stages.value = 0
        toast.add({severity:'success', summary:'Erfolg', detail:'Die Phasen wurden gespeichert', life: 3000})
    })
}

const save_stage_fields = () => {
    loader.value = true
    console.log("save_stage_fields", stage_fields.value)
    axios.post(process.env.VUE_APP_NEURAXIS_API_MAIN + '/gartenkultur/crm/save-stage-fields', {pipeline: pipeline.value, stage: stage.value, stage_fields: stage_fields.value})
    .then(response => {
        console.log("save_stage_fields", response.data)
        loader.value = false
        edits_stage_fields.value = 0
        toast.add({severity:'success', summary:'Erfolg', detail:'Die Phasenfelder wurden gespeichert', life: 3000})
    })
}

</script>
<style lang="scss" scoped>
    @import '@/core/assets/primevue/primeflex.scss';
</style>
<template>
    <div>
        <TabView ref="tabview4">
            <TabPanel>
                <template #header>
                    <i class="pi pi-arrow-down-left mr-2"></i>
                    <span class="mr-3">Prozesse & Phasen</span>
                </template>
                <div class="grid">
                    <div class="col-6">
                        <Dropdown showClear v-model="pipeline" :options="pipelines" optionLabel="name" optionValue="id" placeholder="Prozess auswählen" @change="get_stages(pipeline)" />
                    </div>
                    <div class="col-12" v-if="pipeline">
                        <div rounded class="overflow-hidden shadow-3 border-200 mt-4">
                            <DataTable v-model:editingRows="edit_stage" editMode="row" dataKey="id" @row-edit-save="save_stage" @rowReorder="reorder_stages" :value="stages" :rowHover="true" :rowsPerPageOptions="[20,50,100]" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown" currentPageReportTemplate="{first} bis {last} von {totalRecords}">
                                <Column :rowReorder="true" headerStyle="width: 3rem" :reorderableColumn="false" />
                                <Column field="name" header="Phase">
                                    <template #body="slotProps">
                                        <i class="pi pi-play-circle mr-2 text-primary"></i><span class="font-bold">{{ slotProps.data.name }}</span>
                                    </template>
                                    <template #editor="slotProps">
                                        <InputText v-model="slotProps.data.name" class="w-full" />
                                    </template>
                                </Column>
                                <Column field="id" hidden />
                                <Column :rowEditor="true" style="width: 10%; min-width: 8rem" bodyStyle="text-align:center">
                                    <template #header>
                                        <Button icon="pi pi-plus" class="mr-2 p-button-rounded" v-tooltip.top="'Phase hinzufügen'" @click="create_stage" />
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                        <div class="col-12 mt-2">
                            <Button :disabled="check_for_empty_names() || edits_stages == 0" label="Speichern" icon="pi pi-save" class="mr-2 w-auto p-button-success" @click="save_stages" />
                            <Button label="Zurücksetzen" icon="pi pi-refresh" class="w-auto" @click="get_stages(pipeline), edits_stages = 0" />
                        </div>
                    </div>
                </div>
            </TabPanel>
            <TabPanel>
                <template #header>
                    <i class="pi pi-cog mr-2"></i>
                    <span class="mr-3">Phasenfelder</span>
                </template>
                <div class="grid">
                    <div class="col-6">
                        <Dropdown showClear v-model="pipeline" :options="pipelines" optionLabel="name" optionValue="id" placeholder="Prozess auswählen" @change="get_stages(pipeline)" />
                    </div>
                    <div class="col-6">
                        <Dropdown v-if="pipeline" showClear v-model="stage" :options="stages" optionLabel="name" optionValue="id" placeholder="Phase auswählen" @change="get_stage_fields(pipeline, stage)" />
                    </div>
                    <div class="col-12">
                        <DataTable v-model:editingRows="edit_stage_field" editMode="row" dataKey="id" @row-edit-save="save_stage_field" @rowReorder="reorder_stage_fields" :value="stage_fields" :rowHover="true" :rowsPerPageOptions="[20,50,100]" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown" currentPageReportTemplate="{first} bis {last} von {totalRecords}">
                            <Column :rowReorder="true" headerStyle="width: 3rem" :reorderableColumn="false" />
                            <Column field="name" header="Feldnamen">
                                <template #body="slotProps">
                                    <i class="pi pi-play-circle mr-2 text-primary"></i><span class="font-bold">{{ slotProps.data.name }}</span>
                                </template>
                                <template #editor="slotProps">
                                    <InputText v-model="slotProps.data.name" class="w-full" />
                                </template>
                            </Column>
                            <Column field="type" header="Feldtyp">
                                <template #body="slotProps">
                                    <Chip :label="slotProps.data.type" class="bg-primary" />
                                </template>
                                <template #editor="slotProps">
                                    <Dropdown v-model="slotProps.data.type" :options="field_types" optionLabel="name" optionValue="value" />
                                </template>
                            </Column>
                            <Column field="meta_data" header="Werte">
                                <template #body="slotProps">
                                    <div v-if="slotProps.data.type == 'select'">
                                        <template v-for="meta in slotProps.data.meta_data" :key="meta">
                                            <Chip :label="meta" class="bg-primary" />
                                        </template>
                                    </div>
                                </template>
                                <template #editor="slotProps">
                                    <div v-if="slotProps.data.type == 'select'">
                                        <Fieldset legend="Ausgewählte Produkte" class="w-full pl-3">
                                            <div>
                                                <Chip v-for="(meta) in slotProps.data.meta_data" :key="meta" :label="String(meta)" removable @remove="slotProps.data.meta_data = slotProps.data.meta_data.filter(m => m != meta)" class="mr-2 mt-1" />
                                            </div>
                                            <div class="pl-2 mt-2 flex justify-content-between flex-wrap">
                                                <Button icon="pi pi-plus" class="p-button-rounded p-button-primary ml-auto" @click="add_meta_dialog = true"  v-tooltip.top="'Feldwert hinzufügen'"  />
                                            </div>
                                        </Fieldset>
                                    </div>
                                </template>
                            </Column>
                            <Column field="required" header="Pflichtfeld">
                                <template #body="slotProps">
                                    <i class="pi pi-check text-green-800" v-if="slotProps.data.required" />
                                    <i class="pi pi-times text-red-800" v-else />
                                </template>
                                <template #editor="slotProps">
                                    <Checkbox binary v-model="slotProps.data.required" />
                                </template>
                            </Column>
                            <Column :rowEditor="true" style="width: 10%; min-width: 8rem" bodyStyle="text-align:center">
                                <template #header>
                                    <Button icon="pi pi-plus" class="p-button-rounded p-button-primary" @click="create_stage_field()" v-tooltip.top="'Phasenfeld hinzufügen'" />
                                </template>
                                <template #body="slotProps">
                                    <Button icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text" @click="stage_fields.splice(slotProps.index, 1), edits_stage_fields++" v-tooltip.top="'Feld löschen'" />
                                </template>
                            </Column>
                        </DataTable>
                    </div>
                    <div class="col-12 mt-2">
                        <Button :disabled="edits_stage_fields == 0" label="Speichern" icon="pi pi-save" class="mr-2 w-auto p-button-success" @click="save_stage_fields" />
                        <Button label="Zurücksetzen" icon="pi pi-refresh" class="w-auto" @click="edits_stage_fields = 0, get_stage_fields(pipeline, stage)" />
                    </div>
                </div>
            </TabPanel>
            <TabPanel>
                <template #header>
                    <i class="pi pi-cog mr-2"></i>
                    <span class="mr-3">CRM Stammdaten</span>
                </template>
                
            </TabPanel>
        </TabView>
    </div>
</template>